import React, { useEffect, useState } from "react";
import { Eye, EyeSlash } from "iconsax-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LSSB, setUserData } from "../utils/LSSB_live";
import { ClipLoader } from "react-spinners";
import { enqueueSnackbar } from "notistack";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state;
  const [open, setOpen] = useState(false);
  const [idType, setIdType] = useState("LASRRA");
  const [idNumber, setIdNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [open1, setOpen1] = useState(false);
  const [otp, setOtp] = useState("");

  const toggle1 = () => {
    setOpen1(!open1);
  };



  const toggle = () => {
    setOpen(!open);
  };
  const handleReset = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      let res = await LSSB.make_API_call({
        _endpoint: "reset_password",
        password: password,
        confirm_password: confirmPassword, // -- the new pass confirmation
        otp: otp, // -- from email
        email: email,
      });
      if (res?.success == true) {
        enqueueSnackbar(res?.data?.msg, { variant: "success" });

        navigate("/login");
        setIsLoading(false);
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });



        setIsLoading(false);
      }
    } catch (e) {}
  };

  function handlePassword(event) {
    let new_pass = event.target.value;
    setPassword(new_pass);

    // regular expressions to validate password
    var lowerCase = /[a-z]/g;
    var upperCase = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    if (!new_pass.match(upperCase)) {
      setErrorMessage("Password should contains Uppercase letters!");
    } else if (!new_pass.match(lowerCase)) {
      setErrorMessage("Password should contain lowercase letters!");
    } else if (!new_pass.match(numbers)) {
      setErrorMessage("Password should contains numbers also!");
    } else if (!new_pass.match(specialCharRegExp)) {
      setErrorMessage("Password should contains special character e.g *@#!% !");
    } else if (new_pass.length < 6) {
      setErrorMessage("Password length should be more than 6.");
    } else {
      setErrorMessage("Password is strong!");
    }
    // for confirm password
  }
  const handleConfirmPassword = (event) => {
    let confirm_pass = event.target.value;
    setConfirmPassword(confirm_pass);
    if (confirm_pass !== password) {
      setConfirmPasswordError("Password does not match!");
    } else {
      setConfirmPasswordError("Password match!");
    }
  };

  return (
    <div className="h-screen w-full flex items-center ">
      <div className="h-full w-[20%] md:w-[50%] relative hidden md:block">
        {" "}
        <img
          src="./asset/homeImage.png"
          alt=""
          className="object-cover h-full w-full -z-10"
        />
      </div>
      <div className="h-full w-full md:w-[50%] bg-[#ffff] flex justify-center items-center">
        <div className="md:hidden flex gap-[16px] items-center absolute z-10 top-[24px] left-[24px] md:top-[48px] md:left-[48px]">
          <img
            src="./asset/lssbLogo.png"
            alt="logo"
            className="h-[40px] w-[40px] md:h-[58px] md:w-[58px]"
          />
          <div>
            <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
              Lagos State
            </p>
            <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
              Scholarship Board
            </p>
          </div>
        </div>

        <div className="bg-[#ffff] rounded-[16px] w-[360px] max-w-[360px] sm:w-[480px] sm:max-w-[480px] md:w-[408px] md:max-w-[409px] pt-[24px] md:pt-[32px]  pb-[24px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[20px] md:mb-[30px] xl:mb-[50px]">
            Reset Password
          </h2>

          <form onSubmit={handleReset} className=" w-full">
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Enter OTP
              </label>
              <div className=" ">
                <input
                  type="number"
                  placeholder={`******`}
                  className="w-full h-[50px] px-[16px] py-[12px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value);
                  }}
                  maxLength={6}
                />
              </div>
            </div>

            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                Password
              </label>
              <div className=" ">
                <div className=" relative  flex items-center">
                  <div className="absolute right-[16px]">
                    {open === false ? (
                      <Eye size="16" color="#020408" onClick={toggle} />
                    ) : (
                      <EyeSlash size="16" color="#98A2B3" onClick={toggle} />
                    )}
                  </div>{" "}
                  <input
                    type={open === false ? "password" : "text"}
                    placeholder=""
                    className="w-full h-[40px] px-[16px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    value={password}
                    onChange={(e) => {
                      handlePassword(e);
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>

                {errorMessage && (
                  <p
                    className={` ${
                      errorMessage === "Password is strong!"
                        ? "text-[green]"
                        : "text-[red]"
                    }  pt-1 pl-1 text-left text-xs`}
                  >
                    {" "}
                    {errorMessage}
                  </p>
                )}
              </div>
            </div>
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                Confirm Password
              </label>
              <div className=" ">
                <div className=" relative  flex items-center">
                  <div className="absolute right-[16px]">
                    {open1 === false ? (
                      <Eye size="16" color="#020408" onClick={toggle1} />
                    ) : (
                      <EyeSlash size="16" color="#98A2B3" onClick={toggle1} />
                    )}
                  </div>{" "}
                  <input
                    type={open1 === false ? "password" : "text"}
                    placeholder=""
                    className="w-full h-[40px] px-[16px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    value={confirmPassword}
                    onChange={(e) => {
                      handleConfirmPassword(e);
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>

                {confirmPasswordError && (
                  <p
                    className={` ${
                      confirmPasswordError === "Password match!"
                        ? "text-[green]"
                        : "text-[red]"
                    }  pt-1 pl-1 text-left text-xs`}
                  >
                    {" "}
                    {confirmPasswordError}
                  </p>
                )}
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-[14px] mt-[24px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
            >
              <p className="text-sm font-medium leading-[20px] mr-3">
                Continue
              </p>{" "}
              {isLoading && <ClipLoader color={"white"} size={20} />}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
